import { render, staticRenderFns } from "./resoureces.vue?vue&type=template&id=04da64e5&scoped=true"
import script from "./resoureces.vue?vue&type=script&lang=js"
export * from "./resoureces.vue?vue&type=script&lang=js"
import style0 from "./resoureces.vue?vue&type=style&index=0&id=04da64e5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04da64e5",
  null
  
)

export default component.exports